import * as yup from 'yup';

export const attendanceValidationSchema = yup
  .object({
    employee: yup.string().required('Employee is required'),
    date: yup.date().required('Date is required').nullable().typeError('Invalid date format'),
    check_in_time: yup.string().nullable(),
    check_out_time: yup.string().nullable(),
    status: yup
      .string()
      .required('Status is required')
      .oneOf(['Present', 'Absent', 'On Leave', 'Remote Work', 'Late', 'Half Day'], 'Invalid status selected'),
    remarks: yup.string().trim().max(500, 'Remarks must be less than 500 characters'),
  })
  .test('check-out-after-check-in', 'Check out time must be after check in time', function validateTime(value) {
    // eslint-disable-next-line camelcase
    const { check_in_time, check_out_time } = value;

    // eslint-disable-next-line camelcase
    if (!check_in_time || !check_out_time) {
      return true;
    }

    try {
      // Parse time values
      // eslint-disable-next-line camelcase
      const [checkInHour, checkInMin] = check_in_time.split(':').map(Number);
      // eslint-disable-next-line camelcase
      const [checkOutHour, checkOutMin] = check_out_time.split(':').map(Number);
      
      // Validate time ranges
      if (checkInHour < 0 || checkInHour > 23 || checkInMin < 0 || checkInMin > 59 ||
          checkOutHour < 0 || checkOutHour > 23 || checkOutMin < 0 || checkOutMin > 59) {
        return this.createError({
          path: 'check_out_time',
          message: 'Invalid time format',
        });
      }
      
      // Allow night shifts - check-out can be earlier than check-in (next day)
      // This validation now passes for all valid time combinations
      return true;
    } catch (error) {
      return this.createError({
        path: 'check_out_time',
        message: 'Invalid time format',
      });
    }
  });

/**
 * Check if a check-in time is considered late (after 7:15 PM)
 * @param {string} checkInTime - Time in HH:MM format
 * @returns {boolean} - True if late, false otherwise
 */
export const isCheckInTimeLate = (checkInTime) => {
  if (!checkInTime) return false;
  
  try {
    const [hour, minute] = checkInTime.split(':').map(Number);
    const checkInMinutes = hour * 60 + minute;
    const lateThresholdMinutes = 19 * 60 + 15; // 7:15 PM = 19:15
    
    return checkInMinutes > lateThresholdMinutes;
  } catch (error) {
    return false;
  }
};

/**
 * Determine attendance status based on check-in time
 * @param {string} checkInTime - Time in HH:MM format
 * @param {string} currentStatus - Current status selection
 * @returns {string} - Appropriate status ('Late' or 'Present' based on time)
 */
export const getAttendanceStatusForCheckIn = (checkInTime, currentStatus = 'Present') => {
  // Only auto-adjust for Present and Late statuses
  if (currentStatus === 'Present' || currentStatus === 'Late') {
    if (isCheckInTimeLate(checkInTime)) {
      return 'Late';
    }
    return 'Present';
  }
  return currentStatus;
};

export const getInitialAttendanceFormData = () => ({
  employee: '',
  date: new Date().toISOString().split('T')[0],
  check_in_time: '19:00', // 07:00 PM
  check_out_time: '04:00', // 04:00 AM (next day)
  total_hours: '',
  status: 'Present',
  remarks: '',
});
